export const cropTypes = {
  PEAS: 'peas',
  CORN: 'corn',
  SWEET_CORN: 'sweet corn',
  BEANS: 'beans',
  SHELLED_BEANS: 'shelled beans',
  LIMA_BEANS: 'lima beans',
  LENTIL: 'lentil',
  CHICK_PEA: 'chick pea',
}

export type CropType = (typeof cropTypes)[keyof typeof cropTypes]
